import React, { createContext, useContext, useState } from 'react';
import API from '../services/api';

const AuthContext = createContext(null);

const store = (data) => {
  localStorage.setItem('token', data.token);
  localStorage.setItem('userName', data.user.username);
  localStorage.setItem('userRole', data.user.role);
  if (data.user.isOwner) localStorage.setItem('userIsOwner', '1'); else localStorage.removeItem('userIsOwner');
  if (data.user.mustChangePassword) localStorage.setItem('mustChangePassword', '1');
  else localStorage.removeItem('mustChangePassword');
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const username = localStorage.getItem('userName');
    const role = localStorage.getItem('userRole');
    return username ? { username, role, isOwner: !!localStorage.getItem('userIsOwner'), mustChangePassword: !!localStorage.getItem('mustChangePassword') } : null;
  });

  const login = async (username, password) => {
    const { data } = await API.post('/login', { username, password });
    store(data);
    setUser({ username: data.user.username, role: data.user.role, isOwner: !!data.user.isOwner, mustChangePassword: !!data.user.mustChangePassword });
    return data.user;
  };

  // Changing the password invalidates the old token; the server returns a fresh one.
  const changePassword = async (currentPassword, newPassword) => {
    const { data } = await API.post('/account/password', { currentPassword, newPassword });
    store(data);
    setUser({ username: data.user.username, role: data.user.role, isOwner: !!data.user.isOwner, mustChangePassword: false });
  };

  // An owner renamed this account (Usuarios): the session stays, only the name shown changes.
  const renamed = (username) => {
    localStorage.setItem('userName', username);
    setUser(u => (u ? { ...u, username } : u));
  };

  const logout = () => {
    // Best effort: lets the server record the sign-out. The token is stateless,
    // so failing to reach it must never keep someone logged in.
    API.post('/login/logout').catch(() => {});
    ['token', 'userName', 'userRole', 'userIsOwner', 'mustChangePassword'].forEach(k => localStorage.removeItem(k));
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isLoggedIn: !!user, mustChangePassword: !!user?.mustChangePassword, login, logout, changePassword, renamed }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
